import type { GetProjects200Page } from './getProjects200Page';

/**
 * 프로젝트 목록 응답 데이터
 */
export type GetProjects200 = {
  /** 응답 코드 (성공 또는 에러 식별) */
  code?: string;
  /** 응답 메시지 */
  message?: string;
  page?: GetProjects200Page;
  success?: boolean;
};
